import React from 'react';
import { useState, useEffect } from 'react';
import "./ComponentsCss/NewsList.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// react slick (sider) 
import Slider from "react-slick";
// news item 

import NewsItemGallery from './NewsItemGallery';
import NewsItemExpand from './NewsItemExpand';
// imgs
import NewsImgs from '../imgs/NewsListImgs/card1.png';
import backButton from '../imgs/back.png';

// news expand test 
import mainImg from '../imgs/NewsExpandImgs/cardimg.PNG'
import expCardImg1 from '../imgs/NewsExpandImgs/card2.png';
// axios 
import axios from 'axios';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
 
const NewsList = ({Expanded}) => {

    const navigate = useNavigate(); 
    const { caseId } = useParams();
    
    const [CardExpand, SetCardExpand] = useState(Expanded);
    const [CardSelectedIdx, SetCardSelectedIdx] = useState(0);
    const [NewsListsArray, SetNewsListsArray] = useState();


    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
    };

    useEffect(() => {
        axiosGetNewsLists();
        
    }, []);
    useEffect(() => {
        
        if (NewsListsArray) {
             
            if(Expanded == true && caseId >0){
                //console.log("case Id : " + caseId) ; 
                 for(var i = 0 ; i < NewsListsArray.length ; i++){
                    //console.log(JSON.stringify(NewsListsArray[i].id, null, 2));
                    if(caseId == NewsListsArray[i].id){
                        SetCardSelectedIdx(i);
                    }
                 }
            }
        }
       
    }, [NewsListsArray]);
    const axiosGetNewsLists = async () => {
        console.log(" axiosGetNewsLists ");
        var finalIP = "";
        // https://stepupkorea.kr/api/NewsList/getAllNews
        finalIP = "https://stepupkorea.kr/api/NewsList/getAllNews";
        try {
            const response = await axios.get(finalIP
            );
            if (response) {
                //console.log(response.data);
                SetNewsListsArray(response.data);
            } else {

            }  

        } catch (err) {

            if (!err?.response) {
                console.log('--No Server Response');
            } else if (err.response?.status === 400) {
                console.log('--Missing Username or Password');
            } else if (err.response?.status === 401) {
                console.log('--Unauthorized');
            } else {
                console.log('ERR');
            }

        }
    }


    // https://github.com/akiran/react-slick/issues/1240#issuecomment-51323526123`
    // mainImg, title, description, goalSupp, jointNo, suppNo, descImg, onGoing
    return (
        <>
            <div style={{ height: "90px" }}>
            </div>

            {
                CardExpand == true && NewsListsArray ?
                    <>

                        <div className='back-button-flex'>
                            <img src={backButton} style={{ width: "30px", height: "30px" }} onClick={() => { navigate('/case'); SetCardExpand(false); }}/>
                        </div>
                        <div style={{ width: "100%", margin: "0 auto" }}>
                             
                            <NewsItemExpand
                                         mainImgSrc={NewsListsArray[CardSelectedIdx].mainImg}
                                         title={NewsListsArray[CardSelectedIdx].title}
                                         description={NewsListsArray[CardSelectedIdx].description}
                                         goalSupp={NewsListsArray[CardSelectedIdx].goalSupp}
                                         jointNo={NewsListsArray[CardSelectedIdx].jointNo}
                                         suppNo={NewsListsArray[CardSelectedIdx].suppNo}
                                         descImg={NewsListsArray[CardSelectedIdx].descImg}
                                         onGoing={NewsListsArray[CardSelectedIdx].onGoing}
                                         lawyerId={NewsListsArray[CardSelectedIdx].lawyerId} />
                             

                           
                        </div>
                    </>
                    :
                    <>
                        {
                            /* 
                             <div className="slick-container">

                            <Slider {...settings}>
                                {
                                    NewsListsArray != null && NewsListsArray.length > 0 ?
                                        NewsListsArray.map((newsItem, index) => (

                                            <div>
                                                <div onClick={() => { SetCardExpand(true); SetCardSelectedIdx(index) }}>
                                                    <NewsItem mainImgSrc={newsItem.mainImg} showDetails={false} />
                                                </div>
                                            </div>

                                        ))
                                        : null
                                }
                            </Slider>
                        </div>

                            */
                        }

                        <div className='newsList-gallery'>

                            {
                                NewsListsArray != null && NewsListsArray.length > 0 ?
                                    NewsListsArray.map((newsItem, index) => (
                                        <div>
                                            <div onClick={() => { SetCardExpand(true); SetCardSelectedIdx(index); navigate('/case/'+(newsItem.id));}}>
                                                <NewsItemGallery mainImgSrc={newsItem.mainImg} title={newsItem.title}
                                                    lawyerId={newsItem.lawyerId} deadline={newsItem.deadline}
                                                    jointNo={newsItem.jointNo} goalSupp={newsItem.goalSupp} />
                                            </div>
                                        </div>

                                    ))
                                    : null
                            }



                            <div style={{ marginBottom: "100px" }}>
                            </div>
                        </div>
                    </>

            }


        </>
    )
}

/*


                        {
                            NewsListsArray != null && NewsListsArray.length > 0 ?
                                NewsListsArray.map((newsItem, index) => (
                                    <div key={newsItem.id}>
                                        <div> index  {index}</div>
                                        <div> {newsItem.mainImg}</div>
                                        <div> {newsItem.title}</div>
                                        <div> {newsItem.description}</div>
                                        <div> {newsItem.goalSupp}</div>
                                        <div> {newsItem.jointNo}</div>
                                        <div> {newsItem.suppNo}</div>
                                        <div> {newsItem.descImg}</div>
                                        <div> {newsItem.onGoing}</div>
                                        <div> {newsItem.lawyerId}</div>
                                        <div> {newsItem.deadline}</div>
                                    </div>
                                ))
                                : null
                        }
*/
export default NewsList